import React, { useState } from "react";
import styles from "./report.module.css";
import { Typography } from "@material-ui/core";
import SixMinutesReport from "./SixMinutesReport";
import SleepReport from "./SleepReport";
export default function Reports() {
    const [reportNav, setReportNav] = useState("6mwt"); // "6mwt" | "sleep" - which report section is active

    return (
        <div style={{ marginTop: "3.68rem" }}>
            <div className={styles.container}>
                <div className={styles.mainContent}>
                    <div className={styles.sideNav}>
                        <div
                            className={
                                reportNav === "6mwt"
                                    ? styles.navItemActive
                                    : styles.navItemInactive
                            }
                            onClick={() => setReportNav("6mwt")}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) =>
                                e.key === "Enter" && setReportNav("6mwt")
                            }
                        >
                            <Typography
                                variant="body1"
                                className={styles.navText}
                            >
                                6MWT
                            </Typography>
                        </div>
                        <div
                            className={
                                reportNav === "sleep"
                                    ? styles.navItemActive
                                    : styles.navItemInactive
                            }
                            onClick={() => setReportNav("sleep")}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) =>
                                e.key === "Enter" && setReportNav("sleep")
                            }
                        >
                            <Typography
                                variant="body1"
                                className={styles.navText}
                            >
                                Sleep
                            </Typography>
                        </div>
                    </div>
                    {reportNav === "6mwt" && <SixMinutesReport />}
                    {reportNav === "sleep" && <SleepReport />}
                </div>
            </div>
        </div>
    );
}
